import { startCase } from 'lodash';
import { FinanceType } from '@upstart/harmony/lib/constants';
import { DeskingOfferHistoryInfo } from '@upstart/harmony/lib/legos/deskingTypes';
import { FINANCE_TYPE_PROPERTIES, GLOBAL_PROPERTIES } from './Constants';

export enum RestoreType {
  SINGLE_OFFER = 'single', // we are restoring a single offer
  FINANCE_TYPE = 'financeType', // we are restoring all offers of a given finance type
  GLOBAL = 'global', // we are restoring all offers
}

export const getRestoreType = (
  sortedSnapshots: DeskingOfferHistoryInfo[],
  selectedVersion: number,
) => {
  // get all the properties that have changed since the selected version
  const changedProps = sortedSnapshots
    .filter(offer => offer.version > selectedVersion)
    .reduce((acc, offer) => {
      const allProps = (offer.propertyChanges ?? [])?.map(
        change => change.name,
      );
      acc.push(...allProps);
      return acc;
    }, [] as string[]);
  // now, we use those properties to determine the restore type
  if (GLOBAL_PROPERTIES.some(prop => changedProps.includes(prop))) {
    return RestoreType.GLOBAL;
  }
  if (FINANCE_TYPE_PROPERTIES.some(prop => changedProps.includes(prop))) {
    return RestoreType.FINANCE_TYPE;
  }
  return RestoreType.SINGLE_OFFER;
};

export const getRestoreMessage = (
  restoreType: RestoreType,
  financeType?: FinanceType,
) => {
  if (restoreType === RestoreType.GLOBAL) {
    return `By restoring a pencil with global changes, all pencils will be restored to the same point in time.`;
  }
  if (restoreType === RestoreType.FINANCE_TYPE) {
    return `By restoring a pencil with global changes, all ${startCase(
      financeType ?? '',
    )} pencils will be restored to the same point in time.`;
  }
  return 'Are you sure you want to restore the pencil version?';
};
